<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <fccTable
      striped
      hover
      :fields="configTableGerencFilas.fields"
      :status="configTableGerencFilas.status"
      responsive
      :porPage="itemPorPage"
      search
      pagination
      fieldVisibility
      pdf
      csv
      xls
      :titlePage="titlePage"
      :titlePDF="titlePage"
      :actions="configTableGerencFilas.actions"
      addFilter
      :items="listaFilas"
    />

    <fcc-modal
      centered
      id-modal="modal-filas"
      :title-modal="titleModalSituacao"
      esconde-footer
      trava-esc
      trava-back
    >
      <b-form @submit.prevent="submitModalFilas" autocomplete="off">
        <b-form-group class="position-relative">
          <fcc-input extra-classes="inputLabel" v-model="itemFila.filcodigo" required>
            Código
          </fcc-input>
        </b-form-group>

        <b-form-group class="position-relative">
          <label class="ml-j">Descrição</label>
          <b-form-textarea
            placeholder="Digite a descrição..."
            rows="3"
            v-model="itemFila.fildescricao"
            :state="
              itemFila.fildescricao != null &&
              itemFila.fildescricao.length >= 5 &&
              itemFila.fildescricao.length <= 500
            "
            required
          />
        </b-form-group>

        <b-form-group class="position-relative">
          <div class="row">
            <div class="col-sm-6 text-left">
              <span><toggle-button v-model="itemFila.filativo" :sync="true" /> Ativo</span>
            </div>
          </div>
        </b-form-group>

        <div class="row">
          <div class="col-sm-12 text-right">
            <fccButton
              :disabled="
                itemFila.filcodigo == '' ||
                itemFila.fildescricao == null ||
                itemFila.fildescricao.length <= 5 ||
                itemFila.fildescricao.length >= 500
              "
              classeAdd="form-control"
              tipo="submit"
              >{{ labelsSystem.salvar }}</fccButton
            >
          </div>
        </div>
      </b-form>
    </fcc-modal>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      titlePage: 'Filas',
      itemPorPage: '100',
      listaFilas: [],
      itemFila: {
        filid: 0,
        filcodigo: '',
        fildescricao: '',
        filativo: true
      },

      configTableGerencFilas: {
        fields: [
          { key: 'filid', label: 'ID', sortable: true, active: true },
          { key: 'filcodigo', label: 'Código', sortable: true, active: true },
          { key: 'fildescricao', label: 'Descrição', sortable: true, active: true },
          {
            key: 'filativo',
            label: 'Ativo',
            active: true,
            funcaoButton: this.changeStatusFilas,
            tdClass: 'no-print',
            thClass: 'no-print',
            type: 'toggle',
            objpermCodigo: store.state.permissaoMenu.editar
          },
          { key: 'actions', label: '', thClass: 'no-print', tdClass: 'text-nowrap no-print' }
        ],
        actions: [
          {
            button: true,
            funcaoButton: this.editarFilas,
            icon: 'edit',
            tooltip: 'Editar',
            objpermCodigo: store.state.permissaoMenu.editar
          },
          {
            button: true,
            funcaoButton: this.deletarFilas,
            icon: 'trash-alt',
            tooltip: 'Excluir',
            objpermCodigo: store.state.permissaoMenu.excluir
          }
        ],
        status: [
          {
            funcaoButton: this.editarFilas,
            tooltip: 'Alterar Filas',
            campoStatus: 'ativo',
            objpermCodigo: store.state.permissaoMenu.editar
          }
        ]
      }
    }
  },

  methods: {
    getDadosGerenciamentoFilas: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlTransferenciaArquivos + 'Fila/ListarFila',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaFilas = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },

    addField() {
      this.itemFila = {
        filid: 0,
        filcodigo: '',
        fildescricao: '',
        filativo: true
      }
      this.$bvModal.show('modal-filas')
    },

    editarFilas(_, item) {
      this.itemFila = { ...item }
      this.$bvModal.show('modal-filas')
    },

    deletarFilas(_, item) {
      this.callConfirm(this.mensagemExcluir, item.filcodigo).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C02'))

          axios
            .delete(
              store.state.baseUrlTransferenciaArquivos + 'Fila/ExcluirFila/' + item.filid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.callToast(this.mensagensUpdate.excluido)
              this.getDadosGerenciamentoFilas()
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto)
        }
      })
    },

    changeStatusFilas(_, item) {
      this.itemFila = item
      this.submitModalFilas()
    },

    submitModalFilas() {
      this.carregaTexto(this.codeMensagem('C03'))

      const novoRegistro = this.itemFila.filid == null || this.itemFila.filid == 0
      let request

      if (novoRegistro) {
        request = axios.post(
          store.state.baseUrlTransferenciaArquivos + 'Fila/AdicionarFila',
          this.itemFila,
          this.dadosLoginSession.fccTokenHeaders
        )
      } else {
        request = axios.put(
          store.state.baseUrlTransferenciaArquivos + 'Fila/AlterarFila',
          this.itemFila,
          this.dadosLoginSession.fccTokenHeaders
        )
      }

      request
        .then(() => {
          this.getDadosGerenciamentoFilas()
          this.$bvModal.hide('modal-filas')
          this.callToast(
            novoRegistro ? this.mensagensUpdate.adicionado : this.mensagensUpdate.editado,
            'success'
          )
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },

  computed: {
    titleModalSituacao() {
      return this.itemFila.filid != null && this.itemFila.filid != 0
        ? 'Editar Filas'
        : 'Adicionar Filas'
    }
  },

  created() {
    this.getDadosGerenciamentoFilas()
  }
}
</script>
